import React, { useState } from 'react';
import './Contato.css';

function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    email: '',
    telefone: '',
    mensagem: ''
  });

  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);

  try {
    const response = await fetch("https://script.google.com/macros/s/AKfycbz31p9te6kc8mK_87OkhX9tQNYH25HJTLhseiDbVLXX0ygOBCft3N7RZZebXW_vJx7Rjw/exec", {
      method: "POST",
      body: formData,
    });

    const text = await response.text();
    if (text === "OK") {
      setEnviado(true);
      setFormData({
        nome: '',
        empresa: '',
        email: '',
        telefone: '',
        mensagem: ''
      });
    } else {
      alert("Erro ao enviar. Tente novamente.");
    }
  } catch (error) {
    console.error("Erro ao enviar:", error);
    alert("Erro ao enviar. Tente novamente.");
  }
};

  return (
    <section id="contato" className="contato-section">
      <h2>Entre em Contato</h2>
      <form className="contato-form" onSubmit={handleSubmit}>
        <input type="text" name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
        <input type="text" name="empresa" placeholder="Nome da Empresa" value={formData.empresa} onChange={handleChange} required />
        <input type="email" name="email" placeholder="E-mail" value={formData.email} onChange={handleChange} required />
        <input type="tel" name="telefone" placeholder="Número de Telefone" value={formData.telefone} onChange={handleChange} required />
        <textarea name="mensagem" placeholder="Mensagem" value={formData.mensagem} onChange={handleChange} required />
        <button type="submit">Enviar</button>
        {enviado && <p className="mensagem-sucesso">Mensagem enviada com sucesso!</p>}
      </form>
    </section>
  );
}

export default Contato;
